import { MuiClassCollection } from "../../foundations/mui-class-collection.es.js";
import { palette } from "../../foundations/palette.es.js";
const inputStyleOverrides = {
  root: {
    ".MuiOutlinedInput-notchedOutline": {
      borderColor: palette.border.main
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: palette.border.dark
    },
    [`&.${MuiClassCollection.disabled} .MuiOutlinedInput-notchedOutline, &.${MuiClassCollection.disabled}:hover .MuiOutlinedInput-notchedOutline`]: {
      borderColor: palette.border.light
    }
  }
};
export {
  inputStyleOverrides
};
//# sourceMappingURL=styles.es.js.map
